import * as React from 'react';

function LogoIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={29}
      height={31}
      viewBox="0 0 29 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.669 0L3.372 4.717 3.035 9.94l9.442 4.212L14.669 0zM11.465 18.701l-9.273-3.706L0 28.305l10.79-4.381.675-5.223zM29 5.223L18.04 9.94 15.007 31l10.79-4.886L29 5.223z"
        fill="#FFC931"
      />
    </svg>
  );
}

export default LogoIcon;
